// utils/diffUtils.ts
import { diffChars } from "diff"

export type GroupedChange =
  | { type: "unchanged"; text: string }
  | { type: "change"; removed: string; added: string }
  | { type: "insert"; text: string }
  | { type: "delete"; text: string }

export function groupDiffs(original: string, updated: string): GroupedChange[] {
  const diffs = diffChars(original, updated)
  const result: GroupedChange[] = []

  let i = 0
  while (i < diffs.length) {
    const current = diffs[i]

    if (current.removed && diffs[i + 1]?.added) {
      result.push({ type: "change", removed: current.value, added: diffs[i + 1].value })
      i += 2
    } else if (current.added) {
      result.push({ type: "insert", text: current.value })
      i++
    } else if (current.removed) {
      result.push({ type: "delete", text: current.value })
      i++
    } else {
      result.push({ type: "unchanged", text: current.value })
      i++
    }
  }

  return result
}
